import { z } from 'zod';

export const PROJECT_CODE_SCHEMA = z
    .string()
    .refine(projectCode => /^PJ?\d{2}-\d{5}$/.test(projectCode), { message: 'Invalid project code' });
